// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FMDBW4UbFgoZp8iEHC2L{cursor:pointer;background:var(--background-primary-inverted-primary);border-radius:4px;align-items:center;width:100%;max-width:220px;height:52px;padding-left:8px;padding-right:16px;display:flex;position:relative}.FMDBW4UbFgoZp8iEHC2L.EQkFXATbhEoSlD31tZYk{background:var(--background-neutral-default)}.FMDBW4UbFgoZp8iEHC2L.EQkFXATbhEoSlD31tZYk:hover{background:var(--background-neutral-primary)}.K2ZNAkMfT86eqpcNY6y8{grid-template-columns:max-content max-content;align-items:center;gap:8px;display:grid}.CnTx9xpRae49bljif6SR{display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `FMDBW4UbFgoZp8iEHC2L`,
	"gray": `EQkFXATbhEoSlD31tZYk`,
	"content": `K2ZNAkMfT86eqpcNY6y8`,
	"info": `CnTx9xpRae49bljif6SR`
};
export default ___CSS_LOADER_EXPORT___;
